module.exports = __webpack_public_path__ + "img/regenerate.5f7d5107.svg";